module.exports = __webpack_public_path__ + "static/img/arexo-logo-red-black.c6f0d46d.png";